import { render, staticRenderFns } from "./CategoryMultiSelect.vue?vue&type=template&id=dc9918e0"
import script from "./CategoryMultiSelect.vue?vue&type=script&lang=js"
export * from "./CategoryMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports